import React from 'react';
import { Table } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import OnOffNoLabel from '../OnOffNoLabel';
import OnOffLabel from '../OnOffLabel';

const SelectColumn = ({
  colWidth,
  defaultIndeterminate,
  disabled,
  entity = 'item',
  onCheckBoxClick,
  selected,
  withLabel,
}) => {
  const intl = useIntl();
  return (
    <Table.HeaderCell singleLine width={colWidth} className="aridhia-select-column">
      {withLabel && (
        <OnOffLabel
          className="aridhia-select-column-toggle"
          disabled={disabled}
          checked={selected}
          onClick={onCheckBoxClick}
          label={intl.formatMessage({ id: `table.header.${entity}` })}
          defaultIndeterminate={defaultIndeterminate}
        />
      )}
      {!withLabel && (
        <OnOffNoLabel
          className="aridhia-select-column-toggle"
          disabled={disabled}
          checked={selected}
          onClick={onCheckBoxClick}
          message="hidden.label.table.rows.select"
          label={intl.formatMessage({ id: `hidden.label.table.rows.select.${entity}` })}
        />
      )}
    </Table.HeaderCell>
  );
};

export default SelectColumn;
